import { render, staticRenderFns } from "./TaskO.vue?vue&type=template&id=4c862ed6&scoped=true"
import script from "./TaskO.vue?vue&type=script&lang=ts"
export * from "./TaskO.vue?vue&type=script&lang=ts"
import style0 from "./TaskO.vue?vue&type=style&index=0&id=4c862ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c862ed6",
  null
  
)

export default component.exports